// Dependencies
import React from "react";

// Material UI Components
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Components

// Helpers

// Styles
import {
  formatVehicleName,
  parseDynamicString,
} from "helpers/string-format-helpers";
import { useStyles } from "./Description.styles";

const Description = ({ navRef, genericVehicle }) => {
  const classes = useStyles();

  return (
    <Container
      ref={navRef}
      maxWidth="lg"
      className={classes.descriptionContainer}
      data-component="Description"
    >
      <Typography
        variant="h2"
        className={classes.descriptionSectionTitle}
        data-cy="vehicle-name"
      >
        {`Let's see if ${formatVehicleName(genericVehicle, {
          includeArticle: true,
        })} is a good option for you`}
      </Typography>
      <Grid
        container
        className={classes.specsContainer}
        id="basic-information-content"
      >
        {genericVehicle?.model?.descriptions
          .sort((a, b) =>
            a.modelHeader.position < b.modelHeader.position ? -1 : 1,
          )
          .map((entry) => (
            <>
              <Grid item xs={12} md={4} className={classes.leftDescription}>
                <Typography className={classes.descriptionTitle} variant="h3">
                  {parseDynamicString(
                    entry.modelHeader.body,
                    genericVehicle.model,
                  )}
                </Typography>
              </Grid>
              <Grid item xs={12} md={8} className={classes.rightDescription}>
                <div className={classes.descriptionParagraph}>
                  {entry.paragraph}
                </div>
              </Grid>
            </>
          ))}
      </Grid>
    </Container>
  );
};

export default Description;
